(function () {
  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var locale = document.documentElement.lang || undefined;
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function initHero(root) {
    var thumbs = root.querySelectorAll('[data-hoov-thumb]');
    var slides = root.querySelectorAll('[data-hoov-slide]');

    /* ---------- Gallery: show the slide for a media id ---------- */
    function showMedia(id) {
      if (!id) return;
      id = String(id);
      var found = false;
      slides.forEach(function (s) {
        if (s.dataset.mediaId === id) found = true;
      });
      if (!found) return;

      // Pause every video / external video before switching
      root.querySelectorAll('[data-hoov-slide] video').forEach(function (v) {
        v.pause();
      });
      root.querySelectorAll('[data-hoov-slide] iframe').forEach(function (f) {
        // Reload iframe src to stop YouTube/Vimeo playback
        var src = f.getAttribute('src');
        if (src) f.setAttribute('src', src);
      });

      slides.forEach(function (s) {
        var active = s.dataset.mediaId === id;
        s.hidden = !active;
        s.classList.toggle('is-active', active);
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.mediaId === id);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(thumb.dataset.mediaId);
      });
    });

    /* ---------- Favorites (from original file) ---------- */
    var favoriteButton = root.querySelector('[data-hoov-favorite]');
    if (favoriteButton) {
      var productId = favoriteButton.dataset.productId;
      var storageKey = 'hoov-favorites';

      var getFavorites = function () {
        try {
          return JSON.parse(localStorage.getItem(storageKey)) || [];
        } catch (error) {
          return [];
        }
      };

      var isFavorite = getFavorites().indexOf(productId) !== -1;
      favoriteButton.classList.toggle('is-active', isFavorite);
      favoriteButton.setAttribute('aria-pressed', String(isFavorite));

      favoriteButton.addEventListener('click', function () {
        var favorites = getFavorites();
        var index = favorites.indexOf(productId);
        var nowActive = index === -1;

        if (nowActive) {
          favorites.push(productId);
        } else {
          favorites.splice(index, 1);
        }

        try {
          localStorage.setItem(storageKey, JSON.stringify(favorites));
        } catch (error) {
          /* localStorage unavailable: favorite state won't persist */
        }

        favoriteButton.classList.toggle('is-active', nowActive);
        favoriteButton.setAttribute('aria-pressed', String(nowActive));
      });
    }

    /* ---------- Variants ---------- */
    var form = root.querySelector('form');
    var variantsScript = root.querySelector('[data-hoov-product-variants]');
    var variantIdInput = root.querySelector('[data-hoov-variant-id]');
    var addButton = root.querySelector('[data-hoov-add-button]');
    var priceEl = root.querySelector('[data-hoov-price]');
    var compareEl = root.querySelector('[data-hoov-compare]');
    var selects = root.querySelectorAll('[data-hoov-variant-option]');

    if (variantsScript && selects.length) {
      var variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        variants = [];
      }

      function currentVariant() {
        var chosen = [];
        selects.forEach(function (sel) {
          chosen[Number(sel.dataset.optionPosition) - 1] = sel.value;
        });
        return variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === chosen[i];
          });
        });
      }

      function updateVariant() {
        var variant = currentVariant();

        if (!variant) {
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = 'Unavailable';
          }
          return;
        }

        if (variantIdInput) {
          variantIdInput.value = variant.id;
          variantIdInput.disabled = !variant.available;
        }

        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? 'Add to Cart' : 'Sold out';
        }

        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
          compareEl.hidden = !hasCompare;
          if (hasCompare) compareEl.textContent = formatMoney(variant.compare_at_price);
        }

        // If the variant has its own media, show it (image OR video)
        if (variant.featured_media && variant.featured_media.id) {
          showMedia(variant.featured_media.id);
        }

        // Keep the URL shareable
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      }

      selects.forEach(function (sel) {
        sel.addEventListener('change', updateVariant);
      });
    }

    /* ---------- Quantity fallback (only if theme has no <quantity-input>) ---------- */
    if (!window.customElements || !customElements.get('quantity-input')) {
      root.querySelectorAll('quantity-input').forEach(function (wrap) {
        var input = wrap.querySelector('input[name="quantity"]');
        var minus = wrap.querySelector('button[name="minus"]');
        var plus = wrap.querySelector('button[name="plus"]');
        if (!input) return;
        if (minus) {
          minus.addEventListener('click', function () {
            input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
          });
        }
        if (plus) {
          plus.addEventListener('click', function () {
            input.value = (parseInt(input.value, 10) || 1) + 1;
          });
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.hoov-product-hero').forEach(function (root) {
      if (root.dataset.hoovInit) return;
      root.dataset.hoovInit = 'true';
      initHero(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init inside the Shopify theme editor
  document.addEventListener('shopify:section:load', initAll);
})();
